import _ from 'lodash';
import React, { Fragment, useState, useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Modal, ModalBody, ModalFooter, Button, Table, Form, Input, ToggleSwitch, ProgressBar, Slider } from "@gpstrackit/react-controls";
import { Grid, Card, CardContent, Box, Icon } from '@mui/material'
import { DatePicker } from "@gpstrackit/gtc-react-controls";
import { NotificationManager } from "Components/Notifications";

import Alert from '@mui/material/Alert';
//Internationalization
import { injectIntl } from 'react-intl';

import { HasPermission } from 'Core/security';
import { getBadget } from 'Core/data/Helpers';

//Actions
import {
    vidfleetConfigurationHubSpotHide,
    vidfleetConfigurationHubSpotSave,
    devicesCommonGetDevices,
    generateValidationCode,
    clearRedux
} from "Redux/actions";


const configureHubSpot = (props) => {
    const { messages } = props.intl;
    const dispatch = useDispatch();
    const formEdit = useRef(null);
    const tableRef = useRef(null);

    //Redux states    
    const loading = useSelector(state => state.vidfleetConfigurationHubSpotRedux.loading);
    const openModal = useSelector(state => state.vidfleetConfigurationHubSpotRedux.openModal);
    const saveResult = useSelector(state => state.vidfleetConfigurationHubSpotRedux.saveResult);
    const data = useSelector(state => state.vidfleetConfigurationHubSpotRedux.data);
    const devicesToRecibe = useSelector(state => state.devicesCommonRedux.devices);
    const loadingDevices = useSelector(state => state.devicesCommonRedux.loading);
    const user = useSelector(state => state.securityRedux.user);
    const manufacturers = useSelector(state => state.generalRedux.manufacturers);
    const { loadingVfCode, VfCodeResult } = useSelector(state => state.commonRedux);

    //Local states
    const [title, setTitle] = useState('configuration_hubspot_title');
    const [lastConfig, setLastConfig] = useState(null);
    const [mode, setMode] = useState("Bulk");
    const [step, setStep] = useState(props?.from === "devices" ? 1 : 0);
    const [devices, setDevices] = useState(props.initialDevices || []);
    const [applyScopes, setApplyScopes] = useState([props?.from ? props?.from === "manufacturer" ? "Default" : "Partial" : "Partial"]);
    const [errorMessage, setErrorMessage] = useState("");
    const [deviceSearchCriteria, setDeviceSearchCriteria] = useState("");
    const [applyScopesItems, setApplyScopesItems] = useState([
        { key: "Default", permissionKey: "vftcsd", msgKey: "vidfleet_configuration_apply_scopes_default" },
        { key: "All", permissionKey: "vftcsa", msgKey: "vidfleet_configuration_apply_scopes_all" },
        { key: "Partial", permissionKey: "vftcsp", msgKey: "vidfleet_configuration_apply_scopes_partial" }]);
    let [verificationCode, setVerificationCode] = useState("");
    const [sendfVC, setSendfVC] = useState(false);
    const [codeSent, setCodeSent] = useState(false);
    const [currentConfig, setCurrentConfig] = useState(null);
    const [defaultConfig, setDefaultConfig] = useState({
        enable: false, //default=false; true=enable NAT feature
        cycleBeginDay: 1, //  monthly effective date:1-30, default = 1
        maxMonthlyUsageInMB: 500 //max usage ::MB, default=500
    })


    const hide = () => {

        dispatch(clearRedux("CONFIGURATION_HUBSPOT"))
        setLastConfig(null);

        setDevices([])
        dispatch(vidfleetConfigurationHubSpotHide());
        setCodeSent(false);
    }

    const onValidSubmit = () => {
        //se valida que los imei ingresados no existan en otras subscriptions

        let errorMsg = "";

        let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);;

        if (deviceSearchCriteriaArr.length > 1) {
            let criterias = [];

            deviceSearchCriteriaArr.forEach(criteria => {
                let escCriteria = criteria.trim();

                let regx = /[^a-zA-Z0-9]/g;
                escCriteria = escCriteria.replace(regx, '');

                if (devices && devices.length) {
                    for (let index in devices) {
                        let device = devices[index];

                        if (device.esn != escCriteria) {
                            criterias.push(escCriteria);
                        }
                    }
                } else {
                    criterias.push(escCriteria);
                }
            });


            if (criterias.length) {
                dispatch(devicesCommonGetDevices(criterias));
                setDeviceSearchCriteria(criterias.join(" "));

            }
        } else {
            let isValid = true;

            for (let index in devices) {
                let device = devices[index];

                if (device.esn === deviceSearchCriteria) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_repetead_on_the_list";
                    break;
                }
            }

            if (isValid) {
                dispatch(devicesCommonGetDevices([deviceSearchCriteria]))
            }
        }
        setErrorMessage(errorMsg)
    }

    const onSubmit = () => {

        onValidSubmit();
    }

    const onValidRequiredFields = () => { }

    //resolve data from waylens response
    const resolveData = (data) => {
        let config = null;

        if (props.mode === "Single" && props?.device) {

            if (data?.deviceConfig?.currentNatSettings && !_.isEmpty(data.deviceConfig.currentNatSettings)) { //
                config = data.deviceConfig.currentNatSettings;
            } else if (!data?.deviceConfig?.configurationApplied && data?.deviceConfig?.cloudConfiguration && !_.isEmpty(data.deviceConfig.cloudConfiguration)) { //
                config = data.deviceConfig.cloudConfiguration;
            } else if (data?.fleetConfig?.natSettings && !_.isEmpty(data.fleetConfig.natSettings)) {
                config = data.fleetConfig.natSettings;
            } else {
                config = defaultConfig;
            }
        } else {

            if (data?.fleetConfig?.natSettings && !_.isEmpty(data.fleetConfig.natSettings)) {
                config = data.fleetConfig.natSettings;
            } else
                config = defaultConfig;
        }

        setCurrentConfig(JSON.parse(JSON.stringify(config)))

        //last config
        if (config) {
            setLastConfig(JSON.parse(JSON.stringify(config)))
        }


    }

    //get steps to be render
    const getStepsRender = (step) => {

        switch (step) {
            case 0:
                return (

                    <Card>
                        <CardContent>
                            <Form
                                ref={formEdit}
                                onValidSubmit={onValidSubmit}
                                onSubmit={onSubmit}
                                onValidRequiredFields={onValidRequiredFields}
                            >
                                <Grid>
                                    <Grid container>
                                        <Grid xs={12}>
                                            {messages['vidfleet_configuration_apply_scopes']}
                                            <Grid>
                                                {
                                                    applyScopesItems.map((item, index) => {
                                                        if (HasPermission(user, item.permissionKey, "u"))
                                                            return (
                                                                <div className="d-sm-inline-block mb-1" key={`apply-scopes-${item.key}`} style={{ marginLeft: `${item.key !== "Default" ? "10px" : "0px"}` }}>
                                                                    <div
                                                                        onClick={e => {
                                                                            let applyScps = applyScopes;
                                                                            if (applyScps.includes(item.key)) {
                                                                                applyScps.splice(applyScps.indexOf(item.key), 1);
                                                                            } else if (item.key === "Partial") {
                                                                                applyScps = ["Partial"];
                                                                            } else {
                                                                                if (applyScps.includes("Partial") && item.key != "Partial") {
                                                                                    applyScps.splice(applyScps.indexOf("Partial"), 1);
                                                                                }
                                                                                applyScps.push(item.key);
                                                                            }
                                                                            setApplyScopes([...applyScps]);
                                                                        }}
                                                                    >
                                                                        {
                                                                            getBadget(messages[item.msgKey], applyScopes.includes(item.key))
                                                                        }
                                                                    </div>
                                                                </div>
                                                            )
                                                    })
                                                }
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={12} style={{ marginTop: 10 }}>
                                            {
                                                applyScopes.includes("Default") &&
                                                <Alert severity="error">
                                                    <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
                                                </Alert>
                                            }
                                            {
                                                applyScopes.includes("All") &&
                                                <Alert style={{ marginTop: 3 }} severity="error">
                                                    <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
                                                </Alert>
                                            }
                                            {
                                                applyScopes.includes("Partial") &&
                                                <Alert severity="info">
                                                    <span>{messages["vidfleet_configuration_apply_scopes_partial_message"]}</span>
                                                </Alert>
                                            }
                                        </Grid>
                                    </Grid>
                                    {
                                        applyScopes.includes("Partial") &&
                                        <Grid container spacing={1} style={{ marginTop: 10 }}>

                                            <Grid item xs={6} style={{ marginTop: 10 }}>
                                                <Input
                                                    name="deviceSearchCriteria"
                                                    id="deviceSearchCriteria"
                                                    ref="deviceSearchCriteria"
                                                    label={messages['vidfleet_configuration_device_search_criteria']}
                                                    placeholder={messages["vidfleet_configuration_device_search_criteria"]}
                                                    value={deviceSearchCriteria || ''}
                                                    onChange={(value) => {
                                                        setDeviceSearchCriteria(value);
                                                        setErrorMessage("")
                                                    }}
                                                    required
                                                    requiredMessage={messages['common_field_required']}
                                                    maxLength={500000}
                                                />

                                                {
                                                    errorMessage
                                                    &&
                                                    <span className="fg-danger fs-13">
                                                        {messages[errorMessage]}
                                                    </span>
                                                }
                                            </Grid>

                                            <Grid item xs={3} style={{ marginTop: 34 }}>
                                                <Button
                                                    size="lg"
                                                    className="btn btn-dark-blue"
                                                    disabled={loadingDevices}
                                                    onClick={() => {
                                                        //onValidSubmit();
                                                    }}
                                                >
                                                    {messages["vidfleet_configuration_device_add"]}
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    }
                                </Grid>
                            </Form>
                            {
                                //devices grid
                                applyScopes.includes("Partial") &&
                                <Grid>
                                    <Grid item xs={12}>
                                        <div style={{ width: '100%', marginTop: 15 }}>
                                            <Table
                                                ref={tableRef}
                                                hidePagination
                                                disableItemSelection
                                                data={devices}
                                                columns={[
                                                    {
                                                        key: 1,
                                                        show: true,
                                                        locked: true,
                                                        title: messages["vidfleet_configuration_esn"],
                                                        width: 50,
                                                        field: "esn",
                                                        render: (item) => {
                                                            return (
                                                                <span>{item.esn || ''}</span>
                                                            )
                                                        }
                                                    },
                                                    {
                                                        key: 2,
                                                        show: true,
                                                        locked: false,
                                                        title: messages["vidfleet_configuration_model"],
                                                        width: 150,
                                                        field: "deviceModel",
                                                        sort: true,
                                                        resize: true,
                                                        render: (item) => {
                                                            return (
                                                                <span>{item?.deviceModel?.name || ''}</span>
                                                            )
                                                        }
                                                    },
                                                    {
                                                        key: 3,
                                                        show: true,
                                                        locked: false,
                                                        title: "",
                                                        width: 50,
                                                        sort: true,
                                                        resize: true,
                                                        render: (item) => {
                                                            return (
                                                                <span
                                                                    id="remove-button"
                                                                    className="cursor-pointer"
                                                                    onClick={(e) => {
                                                                        e.preventDefault();
                                                                        let current = devices.lastIndexOf(item);
                                                                        let currentDevices = devices
                                                                        currentDevices.splice(current, 1);
                                                                        setDevices([...currentDevices]);

                                                                    }}
                                                                >
                                                                    <Icon className="toolbar-list-icon">
                                                                        remove_circle
                                                                    </Icon>
                                                                </span>
                                                            )
                                                        }
                                                    }
                                                ]}
                                            />
                                        </div>
                                    </Grid>
                                </Grid>
                            }
                        </CardContent>
                    </Card>
                )
            case 1:
                return (
                    <Card>
                        <CardContent>
                            <Grid
                                container
                                spacing={1}
                            >

                                {
                                    (mode === "Single" && !props?.device?.esn) && !codeSent &&
                                    <Grid xs={12} style={{ marginTop: 20 }}>
                                        <a className="btn-link align-middle" onClick={() => {
                                            //to send the verification code
                                            let manufacturer = manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
                                            dispatch(generateValidationCode("updateVidFleetNat", "VidFleet", manufacturer?.id))
                                            setSendfVC(true);
                                            setCodeSent(true);
                                        }}>
                                            {messages["vidfleet_configuration_send_verification_code"]}
                                        </a>
                                    </Grid>
                                }
                                {
                                    (mode === "Single" && !props?.device?.esn) &&
                                    <Grid xs={12} style={{ marginTop: 20 }}>
                                        <Input
                                            type="text"
                                            label={messages['vidfleet_configuration_verification_code']}
                                            placeholder={messages['vidfleet_configuration_verification_code']}
                                            value={verificationCode || ""}
                                            autoComplete="off"
                                            onChange={(value) => setVerificationCode(value?.trim())}
                                            requiredMessage={messages['required_field']}
                                            required
                                            maxLength={20}
                                        />
                                    </Grid>
                                }

                                {
                                    (applyScopes.includes("Default") || applyScopes.includes("All")) &&
                                    <Grid item xs={12} style={{ marginTop: 10 }}>
                                        {
                                            applyScopes.includes("Default") &&
                                            <Alert severity="error">
                                                <span>{messages["vidfleet_configuration_apply_scopes_default_message"]}</span>
                                            </Alert>
                                        }
                                        {
                                            applyScopes.includes("All") &&
                                            <Alert style={{ marginTop: 3 }} severity="error">
                                                <span>{messages["vidfleet_configuration_apply_scopes_all_message"]}</span>
                                            </Alert>
                                        }
                                    </Grid>
                                }


                                <Grid item xs={12} style={{ marginTop: 15 }}>
                                    <ToggleSwitch
                                        id="hubspotenable"
                                        blueToggle={true}
                                        large={true}
                                        label={messages["configuration_hubspot"]}
                                        optionLabels={[messages["configuration_hubspot_enable"], messages["configuration_hubspot_disable"]]}
                                        checked={currentConfig?.enable}
                                        onChange={(checked) => {
                                            let config = currentConfig
                                            config.enable = checked
                                            setCurrentConfig({ ...config })
                                        }}
                                        width={100}
                                    />
                                    <span>{messages["configuration_hubspot_message"]}</span>
                                </Grid>

                                {
                                    currentConfig?.enable &&
                                    <Grid item xs={12} style={{ marginTop: 15 }}>
                                        {messages["configuration_hubspot_cycle_begin_day"]}
                                        <Slider
                                            min={1}
                                            max={30}
                                            value={currentConfig?.cycleBeginDay}
                                            onChange={(event) => {

                                                let config = currentConfig
                                                config.cycleBeginDay = event
                                                setCurrentConfig({ ...config })
                                            }}
                                            sliderOneColor
                                            showValue
                                            valueLabelDisplay="off"
                                            disabled={!currentConfig.enable}
                                            measure={ordinal(currentConfig?.cycleBeginDay || 1)}
                                        />
                                        <span>{messages["configuration_hubspot_cycle_begin_day_message"]}</span>
                                    </Grid>
                                }
                                {
                                    currentConfig?.enable &&
                                    <Grid item xs={12} style={{ marginTop: 15 }}>
                                        {messages["configuration_hubspot_max_monthly_usage"]}
                                        <Grid item xs={4}>
                                            <div style={{ marginLeft: 0 }}>
                                                <div
                                                    className="d-sm-inline-block mb-1 datausage-pills"
                                                    key="500mb"
                                                    onClick={e => {
                                                        let config = currentConfig
                                                        config.maxMonthlyUsageInMB = 500
                                                        setCurrentConfig({ ...config })
                                                    }}
                                                >
                                                    {
                                                        getBadget(messages["configuration_hubspot_500mb"], currentConfig?.maxMonthlyUsageInMB ? currentConfig?.maxMonthlyUsageInMB === 500 : false)
                                                    }
                                                </div>
                                                <div style={{ marginLeft: 15 }}
                                                    className="d-sm-inline-block mb-1 datausage-pills"
                                                    key="1Gb"
                                                    onClick={e => {
                                                        let config = currentConfig
                                                        config.maxMonthlyUsageInMB = 1000
                                                        setCurrentConfig({ ...config })
                                                    }}
                                                >
                                                    {
                                                        getBadget(messages["configuration_hubspot_1gb"], currentConfig?.maxMonthlyUsageInMB ? currentConfig?.maxMonthlyUsageInMB === 1000 : false)
                                                    }
                                                </div>
                                            </div>
                                        </Grid>

                                        <span>{messages["configuration_hubspot_max_monthly_usage_message"]}</span>
                                    </Grid>
                                }
                            </Grid>
                        </CardContent>
                    </Card>
                )
            case 2:
                return (
                    <Card>
                        <CardContent>
                            {
                                (applyScopes.includes("Default") || applyScopes.includes("All") || !props?.device?.esn) && !codeSent &&
                                <Grid xs={12} style={{ marginTop: 20 }}>
                                    <a className="btn-link align-middle" onClick={() => {
                                        //to send the verification code
                                        let manufacturer = manufacturers.find(x => x?.name?.toUpperCase() === "VidFleet".toUpperCase())
                                        dispatch(generateValidationCode("updateVidFleetNat", "VidFleet", manufacturer?.id))
                                        setSendfVC(true);
                                        setCodeSent(true);
                                    }}>
                                        {messages["vidfleet_configuration_send_verification_code"]}
                                    </a>
                                </Grid>
                            }
                            {
                                (applyScopes.includes("Default") || applyScopes.includes("All") || !props?.device?.esn) &&
                                <Grid xs={12} style={{ marginTop: 20 }}>
                                    <Input
                                        type="text"
                                        label={messages['vidfleet_configuration_verification_code']}
                                        placeholder={messages['vidfleet_configuration_verification_code']}
                                        value={verificationCode || ""}
                                        autoComplete="off"
                                        onChange={(value) => setVerificationCode(value?.trim())}
                                        requiredMessage={messages['required_field']}
                                        required
                                        maxLength={20}
                                    />
                                </Grid>
                            }
                        </CardContent>
                    </Card>
                )
                break;
            default:
                return (<div>empty</div>)
        }
    }

    //To save the upload mode configuration selected
    const saveConfigHubSpot = () => {
        let applScps = applyScopes;
        let esn = props?.device?.esn || null;
        let deviceId = props?.device?.id || null;
        let devicesIds = [];
        let esns = []
        let config = {
            natSettings: {
                enable: currentConfig.enable,
                cycleBeginDay: currentConfig.cycleBeginDay,
                maxMonthlyUsageInMB: currentConfig.maxMonthlyUsageInMB
            }
        }

        if (props.mode === "Bulk" && applScps.includes("Partial")) {
            devices.map((device, index) => {
                esns.push(device.esn);
                devicesIds.push(device.id);
            })
        } else {
            if (esn) {
                esns.push(esn)
                devicesIds.push(deviceId)
            } else if (props.mode !== "Bulk") {
                applScps = ["Default"];
            }
        }

        dispatch(vidfleetConfigurationHubSpotSave(config, esns, devicesIds, lastConfig, applScps, verificationCode))
    }

    const ordinal = (n) => {
        const s = ['th', 'st', 'nd', 'rd'];
        const m = n % 100;
        return (s[(m - 20) % 10] || s[m] || s[0]);
    };

    useEffect(() => {

        if (saveResult) {
            dispatch(clearRedux("CONFIGURATION_HUBSPOT", { saveResult: null }));

            if (!saveResult.error && saveResult?.result !== 'false') {
                NotificationManager.success(
                    "",
                    messages["configuration_hubspot_save_success"],
                    3000,
                    null,
                    null,
                    'success'
                );
                hide();
            }
            else {
                let message = messages["configuration_hubspot_save_error"]
                if (saveResult.error && saveResult.error.error) {
                    if (messages[saveResult.error.error])
                        message = messages[saveResult.error.error]
                    else
                        message = saveResult.error.error.replace("Bad request ->", "").replace("GraphQL error: ", "")
                } else if (saveResult.error && saveResult.error.message)
                    message = messages[saveResult.error.message]

                //Error message
                NotificationManager.error(
                    messages["configuration_hubspot_save_title"],
                    message,
                    3000,
                    null,
                    null,
                    'error'
                );
                setCodeSent(false);
            }

        }

        if (data) {
            dispatch(clearRedux("CONFIGURATION_HUBSPOT", { data: null }))
            if (data?.error?.response?.data?.msg) {
                NotificationManager.error(
                    "",
                    data.error.response.data.msg,
                    6000,
                    null,
                    null,
                    'error'
                );
            }
            if (data?.mode === "Single") {
                if (data?.devices)
                    setDevices(data.devices)
            }
            resolveData(data);

        }

        if (VfCodeResult && sendfVC) {
            dispatch(clearRedux("COMMON", { VfCodeResult: null }));
            setSendfVC(false);
            if (!VfCodeResult.error) {
                if (VfCodeResult.result) {
                    NotificationManager.success(
                        '',
                        messages["vidfleet_configuration_vf_code_sent"],
                        3000,
                        null,
                        null,
                        'success'
                    );
                } else {
                    //Error message
                    NotificationManager.error(
                        messages["configuration_hubspot_title"],
                        messages["vidfleet_configuration_vf_code_error"],
                        3000,
                        null,
                        null,
                        'error'
                    );
                }
            } else {
                //Error message
                NotificationManager.error(
                    messages["configuration_hubspot_title"],
                    messages["vidfleet_configuration_vf_code_error"],
                    3000,
                    null,
                    null,
                    'error'
                );
            }
            //message verification code send
        }

    }, [data, saveResult, VfCodeResult]);

    useEffect(() => {
        if (devicesToRecibe) {
            dispatch(clearRedux("DEVICES_COMMON", { devices: null }))
            let deviceSearchCriteriaArr = deviceSearchCriteria.split(/[\s,;\t\n]+/);
            let errorMsg = ""
            let dvcs = devices;

            if (deviceSearchCriteriaArr.length > 1) {

                if (devicesToRecibe.length === 0)
                    errorMsg = "vidfleet_configuration_device_not_found";

                let devicesReceived = devicesToRecibe.filter(x => {
                    return (deviceSearchCriteriaArr.includes(x.esn))
                })

                let deviceModel = devicesReceived[0].deviceModel;
                devicesReceived.forEach(deviceReceived => {

                    //repeated device
                    var foundDevice = dvcs.find(x => {
                        return x.esn === deviceReceived.esn
                    })

                    if (!foundDevice) {
                        //no VidFleet and diferent model
                        if (deviceReceived.deviceModel.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
                            errorMsg = "vidfleet_configuration_only_vidfleet_devices"
                        } else {
                            dvcs.push(deviceReceived);
                        }

                    } else {
                        errorMsg = "vidfleet_configuration_repetead_on_the_list"
                    }

                });


                setDeviceSearchCriteria("");
                setErrorMessage(errorMsg);
                setDevices(dvcs);

            } else {
                errorMsg = "";
                //valid that has all valid devices
                let isValid = true;

                var device = devicesToRecibe.find(x => {
                    return x.esn === deviceSearchCriteria
                })

                if (!device) {
                    errorMsg = "vidfleet_configuration_device_not_found";
                    isValid = false;
                } else {
                    dvcs.forEach(d => {
                        if (d.esn === device.esn) {
                            errorMsg = "vidfleet_configuration_repetead_on_the_list"
                            isValid = false;
                        }
                    });
                }

                //review if VidFleet is a VidFleet device
                if (device && device.deviceModel.manufacturer.name.toUpperCase() !== "VidFleet".toUpperCase()) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_only_vidfleet"
                }

                //review if is the same device model
                let deviceModel = null;
                if (dvcs.length > 0) {
                    deviceModel = dvcs[0].deviceModel;
                }

                if (dvcs.length > 0 && device && device.deviceModel.name !== deviceModel.name) {
                    isValid = false;
                    errorMsg = "vidfleet_configuration_only_same_model"
                }

                if (isValid) {
                    dvcs.push(device);
                    setDeviceSearchCriteria("");
                    setErrorMessage(errorMsg);
                    setDevices(dvcs);
                } else {
                    setErrorMessage(errorMsg);
                }
            }

        }

    }, [devicesToRecibe]);

    return (
        <Modal
            title={`${messages[title]}`}
            open={openModal}
            size="medium"
            handleClose={() => hide()}
            loading={loading || loadingVfCode}
            position="right"
        >

            <ModalBody style={{ backgroundColor: '#f8f8f8' }}>
                <Grid item xs={12}>
                    {
                        <Grid item className="" style={{ width: '100%' }}>
                            <ProgressBar
                                steps={(applyScopes.includes("Default") || applyScopes.includes("All")) ? 3 : 2}
                                activeStep={step}
                            />
                        </Grid>
                    }
                </Grid>
                <Grid item xs={12}>
                    {getStepsRender(step)}
                </Grid>
            </ModalBody>
            <ModalFooter>
                <Grid container>
                    <Grid item xs={12}>
                        <div style={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Button size="lg" className="btn btn-cancel"
                                onClick={() => { hide(); }}
                            >
                                {messages["common_cancel"]}
                            </Button>
                            {
                                mode === "Bulk" && step > 0 &&
                                <Button size="lg" className="btn btn-dark-blue" onClick={(e) => {
                                    //back step
                                    setStep(step - 1);
                                }}>
                                    {messages["configuration_hubspot_back"]}
                                </Button>
                            }
                            {
                                mode === "Bulk" && ((applyScopes.includes("Default") || applyScopes.includes("All")) ? step < 2 : step === 0) &&
                                <Button size="lg" className="btn btn-dark-blue" disabled={applyScopes.length === 0 || (devices.length === 0 && applyScopes.includes("Partial")) || loadingDevices} onClick={(e) => {
                                    //next step
                                    setStep(step + 1);
                                }}>
                                    {messages["configuration_hubspot_next"]}
                                </Button>
                            }
                            {
                                (mode === "Single" || ((applyScopes.includes("Default") || applyScopes.includes("All")) ? step === 2 : step === 1)) &&
                                <Button
                                    size="lg"
                                    className="btn btn-dark-blue"
                                    disabled={
                                        (mode === "Bulk" && applyScopes.length === 0) ||
                                        (mode === "Bulk" && applyScopes.includes("Partial") && devices.length === 0) ||
                                        (mode === "Bulk" && ((applyScopes.includes("All") || applyScopes.includes("Default")) && verificationCode === "")) ||
                                        (mode === "Single" && (!props?.device?.esn && verificationCode === ""))}
                                    onClick={(e) => {
                                        saveConfigHubSpot();
                                    }}>
                                    {messages["configuration_hubspot_apply"]} {mode === "Bulk" && applyScopes.includes("Partial") ? ` (${devices.length})` : ``}
                                </Button>
                            }
                        </div>
                    </Grid>
                </Grid>
            </ModalFooter>
        </Modal >
    )
}

export default injectIntl(configureHubSpot);